module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-23-042d8020c86f434c9ed184f5afab1264.jpg";